import { render } from "./CreditPassport.vue?vue&type=template&id=2fef2b44&scoped=true"
import script from "./CreditPassport.vue?vue&type=script&lang=js"
export * from "./CreditPassport.vue?vue&type=script&lang=js"

import "./CreditPassport.vue?vue&type=style&index=0&id=2fef2b44&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fef2b44"]])

export default __exports__